export const azure = {
  tenant: process.env.NEXT_PUBLIC_AZURE_TENANT ?? '',
  clientId: process.env.NEXT_PUBLIC_AZURE_CLIENT_ID ?? '',
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
